import * as React from "react";

export const LocaleProviderContext = React.createContext<string | undefined>(
  undefined
);
